export function receive(chatId, message) {
    return {
        type: 'TRADER_CHAT_RECEIVE_MESSAGE',
        chatId,
        message
    };
}
